/* src/app/do-planning/remote-power-details-table/remote-power-details-table.component.css */
:host ::ng-deep .tooltip .ui-tooltip-text {
  max-width: 300px !important;
  height: auto !important;
}
#details-table {
  font-family:
    Arial,
    Helvetica,
    sans-serif;
  border-collapse: collapse;
  width: 100%;
}
#details-table td,
#details-table th {
  border: 1px solid #e0e0e0;
  padding: 8px;
}
#details-table tr:nth-child(even) {
  background-color: #f7f7f7;
}
#details-table tr:hover {
  background-color: #e3e3e3;
  cursor: pointer;
}
#details-table th {
  padding-top: 14px;
  padding-bottom: 14px;
  text-align: left;
  background-color: #a8a8a8;
  color: white;
}
.selected {
  background-color: #d6d6d6;
  border-color: #c7c7c7 !important;
}
button {
  background-color: #a8a8a8 !important;
  color: white;
  border: none;
  width: 250px;
  border-radius: 4px;
  margin-top: 12px;
  cursor: pointer;
  height: 40px;
  transition: 0.2s ease;
}
button:hover {
  background-color: #676767 !important;
}
.button:active {
  transform: scale(0.96);
}
:host ::ng-deep .p-dialog {
  width: min(95vw, 1400px) !important;
  max-width: 95vw !important;
  resize: both;
  overflow: hidden;
}
:host ::ng-deep .p-dialog-content {
  width: 100% !important;
  padding: 20px !important;
  box-sizing: border-box;
  overflow: auto !important;
}
#remote-power-details-table {
  width: 100%;
}
.table-wrapper {
  width: 100%;
}
.table-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}
:host ::ng-deep .rp-results-table,
:host ::ng-deep .rp-results-table .p-datatable,
:host ::ng-deep .rp-results-table .p-datatable-wrapper,
:host ::ng-deep .rp-results-table .p-datatable-table {
  width: 100% !important;
}
:host ::ng-deep .rp-results-table .p-datatable-wrapper {
  max-height: 65vh;
  overflow: auto;
}
:host ::ng-deep .rp-results-table .p-datatable-thead > tr > th,
:host ::ng-deep .rp-results-table .p-datatable-tbody > tr > td {
  padding: 7px 8px !important;
  font-size: 14px;
}
.action-btn {
  flex: 0 0 auto;
}
:host ::ng-deep .rp-results-table .p-datatable-tbody > tr {
  cursor: pointer;
}
:host ::ng-deep .rp-results-table .p-datatable-tbody > tr:hover {
  background-color: #e3e3e3 !important;
}
/*# sourceMappingURL=remote-power-details-table.component.css.map */
